import React from 'react';

import { Typography } from 'app/components/domain/typography';
import { SummaryLine, SummaryPlanLine } from 'app/page/orders/model/products-summary';
import { ProductGroup } from 'app/page/orders/model/order-summary';
import { SummaryLineComponent } from 'app/components/domain/summary-group/product/line/summary-line';
import { SummaryGroupBaseComponent } from 'app/components/domain/summary-group/base-components/summary-group-base-component';

import styles from './summary-group.module.scss';

interface OwnProps {
    title: string;
    summaryPlanLine: SummaryPlanLine;
    summaryGroups?: ProductGroup[];
}

type Props = OwnProps;

class SummaryGroup extends React.PureComponent<Props> {
    public render(): React.ReactNode {
        const { summaryGroups, summaryPlanLine } = this.props;

        return (
            <SummaryGroupBaseComponent
                title={this.renderTitleRow()}
                content={
                    <>
                        <SummaryLineComponent line={summaryPlanLine.line} plan={true} />
                        {summaryPlanLine.discountLine && (
                            <SummaryLineComponent line={summaryPlanLine.discountLine} discount={true} />
                        )}
                        {summaryGroups?.map((group, index) => this.renderProductSummaryGroup(group, index))}
                    </>
                }
            />
        );
    }

    private readonly renderTitleRow = (): React.ReactNode => {
        const { title } = this.props;

        return (
            <Typography variant="subtitle3" component="h4">
                {title}
            </Typography>
        );
    };

    private readonly renderProductSummaryGroup = (group: ProductGroup, groupIndex: number): React.ReactNode => {
        const { groupTitle, lines } = group;

        if (lines.length === 0) {
            return null;
        }

        const tableRowClassName = groupTitle && styles.indentation;

        return (
            <div key={groupIndex} className={styles.summaryGroup}>
                {groupTitle && (
                    <Typography component="span" variant="body1">
                        {groupTitle}
                    </Typography>
                )}
                <div className={tableRowClassName}>
                    {lines.map((line, index) => this.renderGroupSummaryLine(line, index))}
                </div>
            </div>
        );
    };

    private readonly renderGroupSummaryLine = (summaryLine: SummaryLine, index: number): React.ReactNode => (
        <React.Fragment key={index}>
            {summaryLine.chargeLine && <SummaryLineComponent line={summaryLine.chargeLine} />}
            {summaryLine.discountLine && <SummaryLineComponent line={summaryLine.discountLine} discount={true} />}
        </React.Fragment>
    );
}

export { SummaryGroup };
